/* eslint-disable class-methods-use-this */
import { httpService } from './HTTPService';

class DataService {
  private token: string | null = null;

  setToken(token: string | null) {
    this.token = token;
  }

  getItem(collection: string, id: string | undefined) {
    return httpService.fetch('GET', `/.netlify/functions/api/${collection}/${id}`, undefined);
  }

  deleteItem(collection: string, id: string) {
    return httpService.fetch('DELETE', `/.netlify/functions/api/${collection}/${id}`, undefined);
  }

  getItems(collection: string) {
    return httpService.fetch('GET', `/.netlify/functions/api/${collection}`, undefined);
  }

  queryItems(collectionName: string, queryParams: string) {
    return httpService.fetch('GET', `/.netlify/functions/api/${collectionName}?${queryParams}`, undefined);
  }

  async setItem(collection: string, id: string | undefined, data: any) {
    // Let Firebase handle ID generation
    return httpService.fetch('POST', `/.netlify/functions/api/${collection}${id ? `/${id}` : ''}`, data);
  }

  updateItem(collection: string, doc: string|undefined, values: Record<string, any>) {
    return httpService.fetch('PUT', `/.netlify/functions/api/${collection}/${doc}/`, values);
  }

  processAssessment(uid: string|undefined, moduleName?: string) {
    if (moduleName) {
      return httpService.fetch('GET', `/.netlify/functions/processAssessment/${uid}/${moduleName}`, undefined);
    }
    return httpService.fetch('GET', `/.netlify/functions/processAssessment/${uid}`, undefined);
  }

  process(collection: string, uid: string|undefined, moduleName?: string) {
    if (moduleName) {
      return httpService.fetch('GET', `/.netlify/functions/process/${collection}/${uid}/${moduleName}`, undefined);
    }
    return httpService.fetch('GET', `/.netlify/functions/process/${collection}/${uid}`, undefined);
  }

  processAttempts(uid: string|undefined, moduleName?: string) {
    return this.process('attempts', uid, moduleName);
  }

  async reorderItems(data: { collection: string; items: Array<{ id: string; order: number }> }) {
    const response = await fetch('/.netlify/functions/api/reorder', {
      method: 'PUT',
      headers: {
        'Content-Type': 'application/json',
        ...(this.token && { Authorization: `Bearer ${this.token}` }),
      },
      body: JSON.stringify(data),
    });
    return response.json();
  }

  async uploadFile(file: File, path: string) {
    const formData = new FormData();
    formData.append('file', file);
    formData.append('path', path);

    const response = await fetch('/.netlify/functions/upload', {
      method: 'POST',
      body: formData,
    });

    if (!response.ok) {
      const errorText = await response.text();
      console.error('Upload error:', errorText);
      throw new Error(`Upload failed: ${errorText}`);
    }

    return response.json();
  }

  async uploadMultipleFiles(files: { de?: { file: File; path: string }; fr?: { file: File; path: string }; it?: { file: File; path: string } }) {
    const formData = new FormData();

    if (files.de) {
      formData.append('file_de', files.de.file);
      formData.append('path_de', files.de.path);
    }
    if (files.fr) {
      formData.append('file_fr', files.fr.file);
      formData.append('path_fr', files.fr.path);
    }
    if (files.it) {
      formData.append('file_it', files.it.file);
      formData.append('path_it', files.it.path);
    }

    const response = await fetch('/.netlify/functions/upload', {
      method: 'POST',
      body: formData,
    });

    if (!response.ok) {
      const errorText = await response.text();
      console.error('Upload error:', errorText);
      throw new Error(`Upload failed: ${errorText}`);
    }

    return response.json();
  }

  async deleteFile(path: string) {
    return httpService.fetch('DELETE', `/.netlify/functions/upload/${encodeURIComponent(path)}`, undefined);
  }
}

export const dataService = new DataService();
